// Tiny signal-based confirm system, mirroring lib/toast.ts. Import
// confirmDialog() anywhere instead of the native window.confirm();
// ConfirmDialogHost (mounted in Layout) subscribes and renders a themed
// dialog. Resolves true on confirm, false on cancel/Escape/backdrop.

import { signal, type Signal } from "@preact/signals";

export interface ConfirmOptions {
  message: string;
  /** Dialog heading. Defaults to "Bestätigen". */
  title?: string;
  /** Label of the confirming button. Defaults to "OK". */
  confirmLabel?: string;
  /** Label of the cancel button. Defaults to "Abbrechen". */
  cancelLabel?: string;
  /** Style the confirm button as destructive (red). */
  danger?: boolean;
}

export interface ConfirmRequest extends ConfirmOptions {
  id: number;
  resolve: (confirmed: boolean) => void;
}

export const confirmSignal: Signal<ConfirmRequest | null> = signal(null);

let nextId = 1;

export function confirmDialog(input: string | ConfirmOptions): Promise<boolean> {
  const opts: ConfirmOptions = typeof input === "string" ? { message: input } : input;
  return new Promise((resolve) => {
    confirmSignal.value = {
      id: nextId++,
      ...opts,
      resolve: (confirmed) => {
        confirmSignal.value = null;
        resolve(confirmed);
      },
    };
  });
}
